import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgKeyGhost = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill={props.color}
      fillRule='evenodd'
      d='M9.5 8.75c0-1.345.675-2.632 1.897-3.853S13.905 3 15.25 3s2.632.675 3.853 1.897S21 7.405 21 8.75s-.675 2.632-1.897 3.853S16.595 14.5 15.25 14.5s-2.632-.675-3.853-1.897S9.5 10.095 9.5 8.75'
      clipRule='evenodd'
      opacity={0.4}
    />
    <path
      fill={props.color}
      d='m4.5 17 .5 2.5h2.5l2-3h2l1.667-2.5-2.667-3z'
      opacity={0.2}
    />
    <path
      fill={props.color}
      d='M15.25 7.5a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0'
    />
    <path
      fill={props.color}
      fillRule='evenodd'
      d='M10.69 4.19C12.02 2.86 13.546 2 15.25 2s3.23.86 4.56 2.19S22 7.045 22 8.75s-.86 3.23-2.19 4.56-2.855 2.19-4.56 2.19a5.2 5.2 0 0 1-1.69-.287l-1.228 1.842a1 1 0 0 1-.832.445h-1.465l-1.703 2.555a1 1 0 0 1-.832.445H5a1 1 0 0 1-.98-.804l-.5-2.5a1 1 0 0 1 .273-.903l5.244-5.244A5.3 5.3 0 0 1 8.5 8.75c0-1.705.86-3.23 2.19-4.56m1.1 10.073-.825 1.237H9.5a1 1 0 0 0-.832.445L6.965 18.5H5.82l-.234-1.171 4.58-4.581a10.4 10.4 0 0 0 1.624 1.515M15.25 4c-.986 0-2.033.49-3.146 1.604C10.99 6.717 10.5 7.764 10.5 8.75s.49 2.033 1.604 3.146c1.113 1.113 2.16 1.604 3.146 1.604s2.033-.49 3.146-1.604C19.51 10.783 20 9.736 20 8.75s-.49-2.033-1.604-3.146C17.283 4.49 16.236 4 15.25 4'
      clipRule='evenodd'
    />
  </svg>
)
const ForwardRef = forwardRef(SvgKeyGhost)
export default ForwardRef
